import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "../cn";

export type VarianteRkBadge = "brand" | "neutral" | "success";

export type PropsRkBadge = HTMLAttributes<HTMLSpanElement> & {
  readonly variante?: VarianteRkBadge;
  readonly children: ReactNode;
};

export function Badge({
  variante = "neutral",
  className,
  children,
  ...resto
}: PropsRkBadge) {
  return (
    <span
      {...resto}
      className={cn("rk-badge", `rk-badge--${variante}`, className)}
    >
      {children}
    </span>
  );
}
